module.exports = __webpack_public_path__ + "img/instagram_logo.4a8c2347.png";